/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BillDetailGoodsCreateReqVo
 */
export interface BillDetailGoodsCreateReqVo {
    /**
     * 账单ID
     * @type {number}
     * @memberof BillDetailGoodsCreateReqVo
     */
    billId: number;
    /**
     * 实际重量
     * @type {number}
     * @memberof BillDetailGoodsCreateReqVo
     */
    realWeight: number;
    /**
     * 体积重量
     * @type {number}
     * @memberof BillDetailGoodsCreateReqVo
     */
    volumnWeight: number;
    /**
     * 体积合计
     * @type {number}
     * @memberof BillDetailGoodsCreateReqVo
     */
    volumnSum: number;
    /**
     * 体积（CBM）
     * @type {number}
     * @memberof BillDetailGoodsCreateReqVo
     */
    cbm: number;
    /**
     * 箱子长
     * @type {number}
     * @memberof BillDetailGoodsCreateReqVo
     */
    length: number;
    /**
     * 箱子宽
     * @type {number}
     * @memberof BillDetailGoodsCreateReqVo
     */
    width: number;
    /**
     * 箱子高
     * @type {number}
     * @memberof BillDetailGoodsCreateReqVo
     */
    height: number;
    /**
     * 体积适用率
     * @type {number}
     * @memberof BillDetailGoodsCreateReqVo
     */
    volumnApplyRate: number;
    /**
     * 追加快递费用
     * @type {number}
     * @memberof BillDetailGoodsCreateReqVo
     */
    addDeliveryFee: number;
    /**
     * 适用重量
     * @type {number}
     * @memberof BillDetailGoodsCreateReqVo
     */
    applyWeight: number;
}

/**
 * Check if a given object implements the BillDetailGoodsCreateReqVo interface.
 */
export function instanceOfBillDetailGoodsCreateReqVo(value: object): value is BillDetailGoodsCreateReqVo {
    if (!('billId' in value) || value['billId'] === undefined) return false;
    if (!('realWeight' in value) || value['realWeight'] === undefined) return false;
    if (!('volumnWeight' in value) || value['volumnWeight'] === undefined) return false;
    if (!('volumnSum' in value) || value['volumnSum'] === undefined) return false;
    if (!('cbm' in value) || value['cbm'] === undefined) return false;
    if (!('length' in value) || value['length'] === undefined) return false;
    if (!('width' in value) || value['width'] === undefined) return false;
    if (!('height' in value) || value['height'] === undefined) return false;
    if (!('volumnApplyRate' in value) || value['volumnApplyRate'] === undefined) return false;
    if (!('addDeliveryFee' in value) || value['addDeliveryFee'] === undefined) return false;
    if (!('applyWeight' in value) || value['applyWeight'] === undefined) return false;
    return true;
}

export function BillDetailGoodsCreateReqVoFromJSON(json: any): BillDetailGoodsCreateReqVo {
    return BillDetailGoodsCreateReqVoFromJSONTyped(json, false);
}

export function BillDetailGoodsCreateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillDetailGoodsCreateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'billId': json['billId'],
        'realWeight': json['realWeight'],
        'volumnWeight': json['volumnWeight'],
        'volumnSum': json['volumnSum'],
        'cbm': json['cbm'],
        'length': json['length'],
        'width': json['width'],
        'height': json['height'],
        'volumnApplyRate': json['volumnApplyRate'],
        'addDeliveryFee': json['addDeliveryFee'],
        'applyWeight': json['applyWeight'],
    };
}

export function BillDetailGoodsCreateReqVoToJSON(json: any): BillDetailGoodsCreateReqVo {
    return BillDetailGoodsCreateReqVoToJSONTyped(json, false);
}

export function BillDetailGoodsCreateReqVoToJSONTyped(value?: BillDetailGoodsCreateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'billId': value['billId'],
        'realWeight': value['realWeight'],
        'volumnWeight': value['volumnWeight'],
        'volumnSum': value['volumnSum'],
        'cbm': value['cbm'],
        'length': value['length'],
        'width': value['width'],
        'height': value['height'],
        'volumnApplyRate': value['volumnApplyRate'],
        'addDeliveryFee': value['addDeliveryFee'],
        'applyWeight': value['applyWeight'],
    };
}

